import React, { Suspense, useEffect } from "react"
import PricingComponent from "./components/Pricing"
import Footer from "../Home/components/Footer"
import About from "../Home/components/About"
import { useTrack } from "@hackler/react-sdk"
import { GAEvent } from "../../modules/GoogleAnalytics"
import CtaMessage from "../../components/units/CtaMessage"
import { Button } from "@material-ui/core"
import useLoginPopup from "../../hooks/useLoginPopup"
import { Locale } from "../../locale"

const PricingTable = React.lazy(() => import("./components/PricingTable"))
const Faq = React.lazy(() => import("./components/Faq"))

export default function Pricing() {
  const track = useTrack()
  const lang = Locale.getLangCode()
  const loginPopup = useLoginPopup()

  useEffect(() => {
    track({ key: "homepage_pricing_compare_view", properties: { lang } })
  }, [])

  return (
    <>
      <PricingComponent />
      <Suspense fallback={<div />}>
        <PricingTable />
        { lang === "ko" && <Faq /> }
      </Suspense>
      <About
        pageName={"pricing_compare"}
        serviceButtonComponent={({ isMobile, className }) => (
          <Button
            color={"inherit"}
            variant={"contained"}
            fullWidth={isMobile}
            className={className}
            // href={dashboardUrl}
            onClick={() => {
              GAEvent({
                category: "main-6",
                action: "click",
                label: "start abtest",
              })
              track({ key: "homepage_pricing_compare_about_abtest_start_click" })
              loginPopup()
            }}>
            <strong>
              <CtaMessage />
            </strong>
          </Button>
        )}
      />
      <Footer pageName={"pricing_compare"} />
    </>
  )
}
